import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { AttendeeNote } from "../../types/Types";

interface UseGetAttendeeNoteForAttendeeProps {
  eventId: number | string;
  attendeeObjectId: string;
  enabled?: boolean;
}

export function useGetAttendeeNoteForAttendee({
  eventId,
  attendeeObjectId,
  enabled = true,
}: UseGetAttendeeNoteForAttendeeProps) {
  const eid = Number(eventId);
  const oid = (attendeeObjectId || "").trim();

  return useQuery({
    enabled: enabled && eid > 0 && !!oid,
    queryKey: ["attendeeNotes", "forAttendee", eid, oid],
    queryFn: async () => {
      const response = await axiosInstance.get<AttendeeNote | null>(
        getAPIURL(
          `/AttendeeNote/ForAttendee?eventId=${eid}&attendeeObjectId=${encodeURIComponent(oid)}`
        )
      );
      return response.data;
    },
  });
}
